export enum ReportReason {
  Copyright,
  Offensive
}

export enum ReportEventType {
  Comment,
  SubmitChanges,
  Reject,
  Resolved
}

export interface IBookReport {
  id: string;
  bookId: string;
  createdAt: string;
  closedAt?: string;
  reason: ReportReason;
  reporterUserId: string;
  reporterUser: string;
  reportedUser: string;
  reportedUserId: string;
  reportedBook: string;
  comment?: string;
  bookLastModified?: string;
  bookLastEdited?: string;
}

export interface IReportEvent {
  id: string;
  reportId: string;
  bookId: string;
  userId: string;
  username: string;
  created: string;
  eventType: ReportEventType;
  comment?: string;
  eventUserId?: string;
  reportedUserId?: string;
}
